/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_PlanInputs */

const en_settings_overview_plan = /** @type {(inputs: Settings_Overview_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const zh_settings_overview_plan = /** @type {(inputs: Settings_Overview_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套餐`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Settings_Overview_PlanInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_plan = /** @type {((inputs?: Settings_Overview_PlanInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_PlanInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_plan(inputs)
	return zh_settings_overview_plan(inputs)
});
export { settings_overview_plan as "settings.overview.plan" }